import { connect, mapProps } from '@formily/react';
import { CnSelector as UiCnSelector, } from "../../components/cn-selector";
import { mapSize, mapStatus } from "../__builtins__";
export var CnSelector = connect(UiCnSelector, mapProps(mapSize, mapStatus, { dataSource: true }));
CnSelector.displayName = 'CnSelector';
